/**
 * @file User / material analysis UI — pages/Dashboard/User/Home/UserHome.tsx.
 */

import React from "react";
import AnalysisBanner from "../../../../components/common/AnalysisBanner";
import Button from "../../../../components/common/Button";
import UserHomeIntro from "./components/UserHomeIntro";
import UserHomeSteps from "./components/UserHomeSteps";
import DataSpecificitySection from "./components/DataSpecificitySection";
import SpecificityParamsGrid from "./components/SpecificityParamsGrid";
import DataReliabilitySection from "./components/DataReliabilitySection";
import SampleSizeSection from "./components/SampleSizeSection";
import OutputDownloadsSection from "./components/OutputDownloadsSection";
import "./UserHome.css";

interface UserHomeProps {
  onNavigateToMaterialAnalysis?: () => void;
}

const UserHome: React.FC<UserHomeProps> = ({ onNavigateToMaterialAnalysis }) => {
  return (
    <div className="user-home-container">
      {/* Welcome Banner */}
      <AnalysisBanner title="Welcome to ICoMEC" />

      {/* Title and Description */}
      <UserHomeIntro />

      {/* Step-by-Step Process */}
      <UserHomeSteps />

      {/* Data Reliability Framework */}
      <DataReliabilitySection />

      {/* Sample Size and Result Validity */}
      <SampleSizeSection />

      {/* Understanding Data Specificity */}
      <DataSpecificitySection />

      {/* Specificity Parameters Grid */}
      <SpecificityParamsGrid />

      {/* Output and Downloads */}
      <OutputDownloadsSection />

      {/* Explore Dashboard Button */}
      <div className="user-home-cta">
        <Button
          label="Explore Dashboard"
          onClick={onNavigateToMaterialAnalysis || (() => {})}
          type="button"
          variant="default"
        />
      </div>
    </div>
  );
};

/** React component — User Home. */
export default UserHome;
